import { useMemo } from "react";
import { useGetSubscribedTenantsQuery } from "../../app/api/endpoints/tenant.api";
import { useAppSelector } from "../../app/hooks";
import { selectAuthUser } from "../auth/auth.slice";

export function useSubscribedTenants() {
    const authUser = useAppSelector(selectAuthUser);

    const { data, isFetching } = useGetSubscribedTenantsQuery(undefined, { skip: !authUser });

    return { subscribedTenants: data || [], loading: isFetching };
}

export function useSessionTenant() {
    const authUser = useAppSelector(selectAuthUser);
    const { subscribedTenants, loading } = useSubscribedTenants();

    const sessionTenant = useMemo(
        () => subscribedTenants.find((t) => t.id === authUser?.tenantId),
        [subscribedTenants, authUser?.tenantId],
    );

    return { sessionTenant, loading };
}
